<template>
  <b-card>
    <template slot="header">
      <h3>Inserir Contato</h3>
    </template>
    <template>
      <b-form>
        <b-form-group v-if="options != null">
          <b-form-select required v-model="tipoidselecionado" :options="options"></b-form-select>
        </b-form-group>
        <b-form-group prepend="Titulo">
          <b-form-input id="titulo" v-model="form.titulo" type="text" required ></b-form-input>
        </b-form-group>
        <b-form-group prepend="Descrição">
          <b-form-input
            id="descricao"
            v-model="form.descricao"
            type="text"
            required
          ></b-form-input>
        </b-form-group>
      </b-form>
      <b-row>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-button variant="danger" class="mt-3 botao" @click="goBack()">Cancelar</b-button>
        </b-col>
        <b-col xl="6" md="12" lg="6" sm="12">
          <b-button variant="success" class="mt-3 botao" @click="exportarDados">Salvar</b-button>
        </b-col>
      </b-row>
    </template>
  </b-card>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import ContatosVue from "./Contatos.vue";

export default {
  data() {
    return {
      tipoidselecionado: null,
      options: null,
      form: {
        titulo: null,
        descricao: null
      }
    };
  },
  beforeMount() {
    axios
      .get(`${config.default.servidor}/gerencial/retorna-tipos-contato/`, {
        headers: {
          Authorization: "Basic c2E6QURNQUNDRVNZUw=="
        }
      })
      .then(response => {
        if (response.status == 200 && response.data.data.length > 0)
          this.options = response.data.data;
        else this.options = [];
      });
  },

  methods: {
    exportarDados() {
      if (this.checarCampos()) {
        axios
          .put(
            `${config.default.servidor}/gerencial/contatos/`,
            {
              empresaid: localStorage.getItem("enterprise_id"),
              tipoid: this.tipoidselecionado,
              titulo: this.form.titulo,
              descricao: this.form.descricao
            },
            {
              headers: {
                Accept: "application/json",
                Authorization: "Basic c2E6QURNQUNDRVNZUw=="
              }
            }
          )
          .then(response => {
            this.$router.push({ path: `/Contatos` });
          })
          .catch(erro => {
            console.log(erro.response);
          });
      } else {
        const options = { title: "Algo deu errado...", size: "sm" };
        this.$dialogs.alert(
          "Preencha todos os campos antes de continuar.",
          options
        );
      }
    },

    checarCampos() {
      if (this.tipoidselecionado == null) return false;
      if (this.form.titulo == null) return false;
      if (this.form.descricao == null) return false;
      return true;
    },

    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
